export default {
  女装: "Эмэгтэйчүүдийн хувцас",
  男装: "Эрэгтэйчүүдийн",
  手机和小工具: "Гар утас, жижиг хэрэгслүүд",
  居家生活: "Гэрлэлт",
  电脑及周边设备: "Компьютер ба захын тоног төхөөрөмж",
  美容及个人护理: "Гоо сайхан, хувийн тусламж",
  家用电器: "Тоноглол",
  健康与保健: "Эрүүл мэнд, эрүүл мэндийн тусламж үйлчилгээ",
  食品和饮料: "Хоол ундаа",
  玩具_儿童和婴儿: "Тоглоом, хүүхдүүд, нялх хүүхдүүд",
  童装时尚: "Хүүхдийн хувцаслалт",
  视频游戏: "видео тоглоом",
  运动与户外: "Дасгал ба гадаа",
  爱好与书籍: "Хобби ба ном",
  相机和无人机: "Камер, дронууд",
  宠物食品及用品: "Гэрийн тэжээвэр амьтдын хоол хүнс, хангамж",
  女士包袋: "Бүс бүлсний цүнх",
  男士包袋: "Эрэгтэй хүний ​​уут",
  珠宝及配饰: "Үнэт эдлэл, хэрэгслүүд",
  手表: "бугүйн цаг",
  女鞋: "Эмэгтэйчүүдийн гутал",
  男装鞋: "Эрэгтэй гутал",
  汽车: "машин",
  我附近的ShopeePay: "Миний ойролцоох дэлгүүрийн",
  餐饮_旅行和服务: "Хоолны газар, аялал, үйлчилгээ",
  旅行及行李: "Аялал жуулчлал, ачаа тээш",
  各种各样的: "Өөр",
  我是来买什么的: "Би энд худалдаж авах гэж байна",
  对不起_找不到_相关的商品:
    "Уучлаарай, та [{0}] холбогдох бүтээгдэхүүнүүдийг олж чадахгүй байна",
  类别: "зэрэглэл",
  产品: "үр дун",
  店铺: "Дэлгүүр",
  首页: "өмнөх хуудас",
  限时秒杀: "Хязгаарлагдмал цаг",
  博客: "Багана",
  所有品牌: "Бүх брэнд",
  所有类别: "Бүх ангилал",
  我的购物车: "Миний дэлгүүрийн сагс",
  发货信息: "Хүргэлтийн мэдээлэл",
  交货信息: "Хүргэлтийн мэдээлэл",
  付款: "Төлбөр",
  确认: "батлах",
  您的购物车是空的: "Таны сагс хоосон байна",
  价格: "үнэ",
  税: "Албан татвар",
  数量: "тоо хэмжээ",
  总计: "нийт",
  移除: "Зөөх",
  返回商店: "Дэлгүүрт буцах",
  继续发货: "Хүргэлтийг үргэлжлүүлнэ үү",
  筛选: "шүүх",
  价格范围: "Үнэ",
  排序方式: "элбэгх",
  最新: "Өнөөдрийг хүртэл",
  最旧: "Хөгшин",
  价格从低到高: "Бага үнэ хүртэл өндөр",
  价格从高到低: "Өндөр үнэ бага",
  选择交货类型: "Хүргэлтийн төрлийг сонгоно уу",
  送货上门: "Гардуулах",
  继续付款: "Төлбөрөө үргэлжлүүлнэ үү",
  任何其他信息: "Өөр бусад мэдээлэл",
  或者: "эсвэл",
  您的钱包余额: "Таны түрийвчний үлдэгдэл",
  余额不足: "Үлдэгдэл хангалтгүй байна",
  支付: "Төлөх",
  我同意: "Би зөвшөөрч байна",
  条款和条件: "Нөхцөл, болзол",
  退货政策: "Буцаах бодлого",
  隐私政策: "Ганцаардал",
  概括: "Дүгнэх",
  项目: "төсөл",
  全部的: "Бүгдэд нь",
  小计: "Ноорог",
  总运费: "Нийт ачаа",
  有优惠码吗_在这里输入: "Хямдралтай код байна уу? Энд оруулах",
  申请: "Хандах",
  编辑: "хянан засварлах / хэвлэлд бэлтгэх",
  删除: "эдгээх",
  添加新地址: "Шинэ хаяг нэмэх",
  继续交货信息: "Хүргэлтийн мэдээллийг үргэлжлүүлнэ үү",
  选择一个地址: "Хаяг сонгоно уу",
  购买历史: "Түүхийг худалдаж авах",
  下载: "татаж авах",
  已发送退款请求:
    "Буцаан олголтын хүсэлт нь буцаан олголтын хүсэлтийг илгээдэг",
  对比: "эрс ялгаа",
  对话: "яволцуулах",
  我的钱包: "Миний түрийвч",
  工单: "Ажлын захиалга",
  管理个人资料: "Хувийн мэдээллийг удирдах",
  登出: "Гарах",
  重置对比列表: "Харьцуулах жагсаалтыг дахин тохируулах",
  您的对比列表为空: "Таны харьцуулах жагсаалт хоосон байна",
  在您的购物车中: "Худалдааны сагсанд",
  在您的愿望清单中: "Таны хүслийн жагсаалтад",
  在您的预定列表中: "Таны хуваарьт жагсаалтад",
  下载您的产品: "Бүтээгдэхүүнээ татаж авах",
  选项: "Сонголт",
  什么都没找到: "Би юу ч олоогүй",
  特色产品: "Наалт",
  最畅销: "Хамгийн сайн",
  前_名: "Өмнөх {0} нэр",
  查看更多: "Илүү ихийг үзэх",
  查看所有类别: "Бүх ангиллыг харах",
  十大品牌: "Шилдэг арван брэндүүд",
  查看所有品牌: "Бүх брэндүүдийг үзэх",
  登录: "Нэвтрэх",
  手机号码: "утасны дугаар",
  密码: "нууц үг",
  密码长度为6到16个字符: "Нууц үгний урт нь 6-аас 16 тэмдэгт байна",
  验证码: "Шалгалт",
  登录中: "Нэвтрэх",
  游客登录: "Аялал жуулчлалын Нэвтрэх",
  注册您的商店: "Дэлгүүрээ бүртгүүлнэ үү",
  现在申请: "Одоо хэрэгжүүлэх",
  成为商家: "Худалдаачин болох",
  现在注册: "Одоо бүртгүүл",
  登录成功: "Амжилттай нэвтрэх",
  通知: "зарлах",
  未找到通知: "Мэдэгдэл байхгүй",
  评论: "Сэтгэгдэл",
  估计运输时间: "Тээврийн хэрэгслийн тооцоолсон цаг",
  天: "тэнгэр",
  所售: "Худалдаа",
  给商家留言: "Худалдаачинд мессеж үлдээгээрэй",
  规格: "Лал дох үйл",
  库存: "хувьцаанд Стан байхгүй",
  总价: "Гол үнэ",
  添加到购物车: "Картанд нэмэх",
  立即购买: "Одоо худалдаж ав",
  缺货: "зарагдаж дууссан",
  添加到愿望清单: "Хүсэлтийн жагсаалтад нэмэх",
  加入对比列表: "Харьцуулах жагсаалтыг нэмэх",
  退款: "Буцаан олголт",
  查看条款: "Өгүүлбэрийг үзэх",
  分享: "хуваах",
  描述: "тойрог татах",
  相关产品: "Холбоотой бүтээгдэхүүн",
  没有人问过商家: "Хэн ч худалдаачингаас асуусангүй",
  该产品暂无评论: "Энэ бүтээгдэхүүнд ямар ч сэтгэгдэл байхгүй байна",
  客户评论: "Хэрэглэгчийн сэтгэгдэл",
  访问商店: "Дэлгүүр үзэх",
  畅销产品: "Хамгийн сайн -Selling бүтээгдэхүүн",
  日期: "огноо",
  订单编号: "Захиалгын дугаар",
  总额: "бөөн дүн",
  状态: "улс гурэн",
  愿望清单: "Хүслийн жагсаалт",
  还没有添加任何东西: "Хараахан нэмээгүй байна",
  注册: "бүртгүүлэх",
  邀请码: "Хувь урилга ватмар код",
  请输入邀请码: "Урилгын кодыг оруулна уу",
  用户名: "Хэрэглэгчийн",
  请输入用户名: "Хэрэглэгчийн нэрийг оруулна уу",
  用户名长度为6_14个字符: "Хэрэглэгчийн нэр урт нь 6-14 тэмдэгт байна",
  昵称: "Нийт 1 нэр",
  请输入手机号码: "Гар утасны дугаарыг оруулна уу",
  手机号码格式错误: "Гар утасны дугаарын форматын алдаа",
  密码长度为6_16个字符: "Нууц үгний урт нь 6-16 тэмдэгт юм",
  确认密码: "Нууц үгээ баталгаажуулах",
  请输入确认密码: "Баталгаажуулах нууц үгийг оруулна уу",
  提款密码: "ЧАМАГИЙН нууц үг",
  请输入提款密码: "Татан авах нууц үгийг оруулна уу",
  提款密码长度为4_16个字符: "Татах нууц үгний урт нь 4-16 тэмдэгт юм",
  请输入验证码: "Баталгаажуулах кодыг оруулна уу",
  在_s后发送: "{0} s дараа илгээнэ үү",
  发送验证码: "Баталгаажуулах кодыг илгээнэ үү",
  注册即表示您同意我们的条款和条件:
    "Бүртгэл нь та манай нөхцөл, болзлыг хүлээн зөвшөөрч байгаа гэсэн үг юм.",
  创建账号: "Бүртгэл үүсгэх",
  验证码发送成功: "Баталгаажуулах кодыг амжилттай илгээдэг",
  确认密码不一致: "Нууц үг нийцэхгүй байгааг баталгаажуулна уу",
  提款密码必须为数字: "Татаж авах нууц үгийг дугаарлах ёстой",
  注册成功: "Амжилттай бүртгүүлнэ үү",
  购物车: "Дэлгүүрийн түрдэг тэрэг",
  账户: "Данс",
  我的账户: "Миний данс",
  已经有一个账户: "Данс аль хэдийн орсон байна",
  新地址: "Шинэ хаяг",
  编辑地址: "Ретантэр өгөх хаяг",
  保存: "аврах",
  是否默认: "Анёуулт мэдээлэл",
  具体地址: "Тодорхой хаяг",
  请输入具体地址: "Тодорхой хаягийг оруулна уу",
  地区: "талбай",
  请输入地区: "Талбайг оруулна уу",
  城市: "Хот",
  请输入城市: "Хотоо оруулна уу",
  省份: "хошуу",
  请输入省份: "Аймагийг оруулна уу",
  邮政编码: "шуудангийн код",
  请输入邮政编码: "Шуудангийн кодыг оруулна уу",
  电话号码: "утасны дугаар",
  请输入电话号码: "Утасны дугаарыг оруулна уу",
  收货人: "хүлээн авагч",
  请输入收货人: "Хүлээн авагчийг оруулна уу",
  保存成功: "Амжилттай байх",
  最畅销的商家: "Хамгийн сайн худалдаачин",
  查看所有的商家: "Бүх худалдаачдыг шалгана уу",
  支持政策: "Хөтөгэмжтэй бодлого",
  您的电子邮件地址: "Таны и-мэйл хаяг",
  订阅: "захиалга",
  联系方式: "Холбогдох мэдээлэл",
  地址: "хаяглах",
  美国伊利诺伊州霍夫曼庄园: "Холфман Манор, Иллинойс, АНУ",
  快速链接: "Хурдан холбох",
  商家政策: "Ерөнхий оюун ухааны бодлого",
  submit: "бууж өгөх",
  提款银行卡: "Зөөлт карт",
  我的面板: "Миний самбар",
  提示: "дохио",
  确定登出吗: "Та нэвтэрч байгаа гэдэгтээ итгэлтэй байна уу?",
  确定: "Баттай",
  取消: "Цуаах",
  项目添加到您的购物车: "Төслийг таны дэлгүүрийн сагсанд нэмж оруулав",
  经常一起购买: "Байнга худалдаж аваарай",
  返回购物: "Дэлгүүр хэс",
  进行结算: "Тооцоо хийхдээ үргэлжлүүлнэ үү",
  帮助热线: "ХӨДӨЛГӨӨНИЙ ХӨДӨЛМӨР",
  查看所有通知: "Бүх мэдэгдлийг шалгана уу",
  请输入密码: "Нууц үгээ оруулна уу",
  前往充值: "Цэнэглэхээр яв",
  购物车物品: "Дэлгүүрийн түрдэг тэрэг",
  查看购物车: "Худалдааны сагсыг шалгана уу",
  钱包余额: "Түрүүвч",
  充值钱包: "Цэнэглэдэг цүнх",
  钱包充值_线下_: "Түрийвч цэнэглэх (офлайн)",
  申请提款: "Татан авах өргөдөл гаргах",
  钱包收支明细: "Түрийвчний орлого, зарлагын дэлгэрэнгүй мэдээлэл",
  批准: "зөвшөөрөх",
  提现历史记录: "Түүхэн бичлэгийг ажилд авах",
  类型: "маяг",
  信息: "мэдээлэл",
  付款方式: "Төлбөрийн нөхцөл",
  请选择付款方式: "Төлбөрийн аргыг сонгоно уу",
  Bill_Type_RECHARGE_BACK: "Арын цэнэглэлт",
  Bill_Type_RECHARGE_ONLINE: "Онлайн цэнэглэгч",
  Bill_Type_RECHARGE_REGISTER: "Бүртгүүлэх",
  Bill_Type_RECHARGE_JACKPOT: "Шалгаадаалаа",
  Bill_Type_RECHARGE_PRESENT: "Цэнэглэх шагнал",
  Bill_Type_RECHARGE_FROM_COMMISSION: "Алдар нэвтрүүлэх шилжилт",
  Bill_Type_RECHARGE_TG_COMMISSION: "Цэнэглэх урамшууллын комисс",
  Bill_Type_REGISTER_TG_COMMISSION: "Бүртгүүлэх болон сурталчилгааны комисс",
  Bill_Type_WITHDRAW: "Унрэх",
  Bill_Type_WITHDRAW_REJECT: "Унрэх",
  Bill_Type_DEDUCT_HANDLE: "Гарын авлагны хувалт",
  Bill_Type_DEDUCT_RECHARGE_MONEY: "Шалгаадаалаа",
  Bill_Type_MINING_PROFIT: "Усан орон Проц",
  Bill_Type_MINING_PROFIT_COMMISSION: "Уул уурхайн орлогын сургалтын комисс",
  Bill_Type_VIP_UPGRADE: "Шинэчлэх VIP",
  Bill_Type_FINANCE_BUY: "Баялгийн менежментийн бүтээгдэхүүний худалдан авалт",
  Bill_Type_FINANCE_CAPITAL_RETURN: "Санхүүгийн үлдэгдэл буцах",
  Bill_Type_FINANCE_FEE: "Санхүүгийн харьцах төлбөр",
  Bill_Type_FINANCE_PROFIT: "Санхүүгийн орлого",
  Bill_Type_FINANCE_BUY_COMMISSION:
    "Удирдлагын менежментийн бүтээгдэхүүний комисс худалдаж авах",
  Bill_Type_FINANCE_PROFIT_COMMISSION:
    "Баялгийн менежментийн бүтээгдэхүүний орлогын комисс",
  Bill_Type_WHEEL_DRAW: "Том эргэлтийн сугалаа",
  Bill_Type_BUY: "Бараа худалдаж авах",
  Bill_Type_PAY_SHOP: "Хүргэлтийн төлбөр төлөх",
  Bill_Type_BUY_COMMISSION: "Бараа хураамж авах",
  Bill_Type_DEPOSIT: "Хадгаламж төлөх",
  Bill_Type_STORE_BUY: "Бараа худалдаж авах",
  Bill_Type_STORE_BUY_REFUND: "Буцаан авах",
  Bill_Type: "Өрийн өөрчлөлтийн төрөл",
  Before_Money: "Өмнөх хэмжээ",
  Deal_Money: "Дансны хэмжээг өөрчлөх",
  After_Money: "Дараагийн дүн",
  Bill_Time: "Данс цаг хугацааг өөрчлөх",
  No_More_Data: "Мэдэхгүй байна",
  Apply_Money: "Програмын ний дүн",
  Apply_Time: "Програмын цаг",
  Withdraw_Info: "Харьцуулах хураамж: {Төлбөр}, данс руу: {мөнгө}",
  提款订单状态_CHECKING: "Хянаж үзэх",
  提款订单状态_TRANSFERRING: "Гуйвуулга",
  提款订单状态_PASS: "Батлах",
  提款订单状态_REJECT: "Тэтгэсэн",
  暂无可用充值方式: "Цэнэглэдэг дахин цэнэглэх арга байхгүй",
  钱包收款码: "Түрийвч цуглуулах код",
  钱包地址: "Түрий яриа",
  金额限制: "Хэмжээг хязгаарлана уу",
  复制: "хуулах",
  付款凭证: "Төлбөрийг төлөх эрхийн бичиг",
  收款银行: "Авлагын банк",
  收款人: "Мөнгөний нярав / кассчин",
  收款账号: "Хрекийн данс",
  付款银行: "Төлөх банкны банк",
  付款人: "Хийн угаагч",
  付款账号: "Төлбөрийн данс",
  请输入付款银行: "Төлбөрийн банкийг оруулна уу",
  请输入付款人: "Төлбөр төлөгч оруулна уу",
  请输入付款账号: "Төлбөрийн дансыг оруулна уу",
  请上传付款凭证: "Төлбөрийн эрхийн бичгийг байршуулна уу",
  充值金额: "Цэнэглэх дүн",
  请输入充值金额: "Цэнэглэх дүнг оруулна уу",
  submitting: "Ирүүлсэн ...",
  Confirm: "бууж өгөх",
  Commit_Success: "Амжилттай танилцуулга",
  balanceType_BALANCE: "Тэнцвэр",
  balanceType_COMMISSION: "даалгавар",
  Balance: "Дансны үлдэгдэл",
  Wash_Money: "Хуваах",
  请选择银行账户: "Банкны дансаа сонгоно уу",
  卡号类型: "Картны дугаар",
  提现金额: "Татах хэмжээ",
  提款金额: "Татах хэмжээ",
  不能为空: "Хоосон байж болохгүй",
  金额不正确: "Буруу тогтоосон",
  please_input_withdraw_password: "Татан авах нууц үгийг оруулна уу",
  withdraw_password_format_error:
    "Татаж авах нууц үг 4-16 битийн тэмдэгт байх ёстой",
  Fee: "Боловсруулах хураамж",
  实际到账: "Үнэн хэрэгтээ",
  交易币种: "Худалдааны валют",
  原始密码: "Custrafit нууц үгс",
  confirm_password_error: "Хоёр оролтын нууц үг буруу байна",
  save_success: "Амжилттай байх",
  please_input: "Үүж оруулна уу",
  old_password: "Хуучин нууц үг",
  new_password: "Шинэ нууц үг",
  please_input_confirm_password: "Нууц үгийг дахин баталгаажуулна уу",
  没有找到符合条件的商品: "Мэргэшсэн бүтээгдэхүүн олж чадахгүй байна",
  Search: "эрэл хайгуул хийх",
  全部: "бүгд",
  EnumGoodsOrderState_USER_PAY: "Тараах",
  EnumGoodsOrderState_SHOP_PAY: "Хувиарилалт",
  EnumGoodsOrderState_SUCCESS: "Дуусах",
  EnumGoodsOrderState_CANCEL: "Цуаах",
  EnumGoodsOrderState_REFUND_SUCCESS: "Буцаан олголт",
  订单号: "Захиалгын дугаар",
  用户名称: "Скэдхэн нэр",
  收益: "орлого",
  支付时间: "Төлөх хугацаа",
  配送时间: "Хүргэгдэх хугацаа",
  完成时间: "Дуусгах цаг",
  发货: "Усан онгоц",
  全选: "Бүрэн сонголт",
  物品已添加到愿望清单: "Энэ зүйлийг хүслийн жагсаалтад нэмсэн",
  物品已添加到比较列表: "Эдгээр зүйлсийг харьцуулах жагсаалтад нэмсэн",
  购买成功提示: "Баяр хүргэе, амжилттай худалдаж аваарай",
  订单列表: "Захиалгын талбар хайх",
  商品名: "Бүтээгдэхүүний нэр",
  图片: "зураг",
  没有品牌: "Брэнд байхгүй",
  基本信息: "Үндсэн мэдээлэл",
  Account_Name: "Нэр",
  Bank_Account: "Банкны данс",
  Bank_Phone: "Гар утасны дугаарыг нөөцлөх",
  IFSC: "IFSC данс",
  UPI: "Upi данс",
  PIX: "PIX дансны дугаар",
  CPF: "CPF данс",
  GCASH: "Gcash данс",
  POWWI: "Powerwi данс",
  身份证号: "ID дугаар",
  Edit: "Шалгах",
  Delete: "эдгээх",
  Add: "Өсөлт",
  Forget_Withdraw_Password: "Нэхэмжлэлийн нууц үгээр март",
  Bank_Card_Info: "Банкны карт мэдээллийн мэдээллийн өдөр",
  收款人地址: "Кассаторын хаяг",
  SWIFT: "Суулан",
  Bank_Branch: "Дэд -band нэр",
  分行代码: "Салбарын код",
  银行地址: "Банкны хаяг",
  Email: "Байлдлаа",
  银行卡长度必须超过: "Банкны картын урт {урт} -оос давсан байх ёстой",
  银行卡格式不正确: "Банкны картын формат буруу байна",
  Do_you_confirm_delete: "Та устгахыг баталгаажуулна уу?",
  Please_Login_First: "Дахин нэвтэрч орно уу",
  Bank_Name: "Банкны нэр",
  Please_add_bank_first: "Та банкны картыг холбоогүй, үүнийг нэмж оруулна уу",
  withdrawType: "Тэтгэмж",
  withdraw_money_limit: "Татан авах хэмжээ нь 0-ээс бага байх ёстой {үлдэгдэл}",
  withdraw_times_limit:
    "Та өнөөдөр {Bightwithdrownum} -ийг {{limittimawnum} цаг хугацааны дараа та харьцах төлбөрийн дараа {татан буугдах болно. Мөнгө буцааж авахаар шийдсэн үү?",
  Copy_Success: "Хуулбар",
  商店首页: "Нүүр хуудас хадгалах",
  所有产品: "Бүх бүтээгдэхүүн",
  新到货产品: "Шинэ -",
  所有商家: "Бүх худалдаачид",
  请上传: "Байршуулна уу",
  请输入: "Үүж оруулна уу",
  忘记密码: "Нууц үгээ март",
  记得我: "Намайг санах уу санаж",
  共_件: "Нийт {0} хэсэг",
  取消订单: "Захиалгыг цуцлах",
  申请退款: "Буцаан авах өргөдөл гаргах",
  未知商家: "Наймаачин",
  到账: "Данс",
  提款订单状态: "Захиалга өгөх статус",
  前_名类别: "Эхний {0} ангилал",
  取消订单原因_不想要了: "Хүсэхгүй байна",
  取消订单原因_商品错选_多选: "Бүтээгдэхүүний алдаа / олон сонголт",
  取消订单原因_商品无货: "Гадагш гарах -of -goods",
  取消订单原因_地址信息填写错误: "Хаягийн мэдээллийн алдааг бөглөнө үү",
  取消订单原因_商品降价: "Барааны үнийн бууралт",
  取消订单原因_价格高于其他平台: "Үнэ нь бусад платформоос өндөр байна",
  取消订单原因_没用_少用_错用优惠:
    "Юу ч биш / бага / алдааны хөнгөлөлтийг ашиглах",
  退款原因_拍错_多拍_不喜欢: "Буруу / гөлөг авах / илүү их, таалагдахгүй байна",
  退款原因_商品成分描述不符:
    "Бүтээгдэхүүний бүрэлдэхүүн хэсгийн тодорхойлолт таарахгүй байна",
  退款原因_与商家协商一致退款: "Худалдааны буцаан олголттой зөвлөлдөх",
  退款原因_生产日期_保质期与商品描述不符:
    "Үйлдвэрлэлийн огноо / тавиурын амьдрал нь бүтээгдэхүүний тайлбартай таарахгүй байна",
  退款原因_图片_产地_批号_规格等描述不符:
    "Зураг / гарал үүсэл / Багцын дугаар / ТЕХНИКИЙН НЭГДСЭН, ГАЗРЫН ГАЗАР.",
  退款原因_质量问题: "Хатуу байдал",
  退款原因_商品变质_发霉_有异物: "Бүтээгдэхүүний олз / хөгц / гадаад бие",
  退款原因_少件_含缺少配件_:
    "Бяцхан зүйлс (дагалдах хэрэгслийн дутагдал гэх мэт)",
  退款原因_收到商品时有破损_污渍_变形:
    "Бүтээгдэхүүнийг хүлээн авахдаа хохирол / толбо / гажиг байдаг",
  退款原因_假冒品牌: "Хуурамч бичиг үйлдэх",
  退款原因_发票问题: "Нэхэмжлэлийн асуудал",
  退款原因_商家发错货: "Худалдаачид буруу бараа илгээдэг",
  退款原因_预约不到_商家不给退换:
    "Уулзалт / худалдаачинг буцааж өгөх боломжгүй",
  退款失败: "Буцаан олголтын алдаа",
  退款处理中: "Буцаан олголт боловсруулах",
  默认: "үл хүрэлцэх",
  产品查询: "Бүтээгдэхүүний асуулт",
  商店LOGO: "Дэлгүүрийн лого",
  推广码: "Дэмжих хийнэ",
  查看所有: "Бүгдийг шалгах",
  确认收货成功: "Хүлээн авалт амжилттай болсон эсэхийг баталгаажуулна уу",
  物流公司: "Ложистик компани",
  物流单号: "Логистикийн захиалгын дугаар",
  发货时间: "Хүргэгдэх хугацаа",
  请先选择商品规格: "Эхлээд бүтээгдэхүүний тодорхойлолтыг сонгоно уу",
  个人信息: "Хувийн мэдээлэл",
  您的用户名: "Таны хэрэглэгчийн нэр",
  你的名字: "Нэр",
  登录名: "Хэрэглэгчийн",
  你的邮件: "Таны Захууд",
  你的密码: "Таны нууц үг",
  重复输入密码: "Нууц үгээ давт",
  店铺名称: "Дэлгүүрийн нэр",
  证书类型: "Маяг",
  身份证: "Үнэм тээврийн карт",
  护照: "паспорт",
  驾驶执照: "жолоочийн үнэмлэх",
  社会保障卡: "Нийгмийн даатгалын карт",
  证书正面: "Хувь журам",
  证书反面: "Баталгаа",
  确认收货: "Бараа хүлээн авахыг баталгаажуулна уу",
  请选择取消订单的原因必选:
    "Захиалгыг цуцлах шалтгааныг сонгоно уу (шаардлагатай):",
  请选择申请退款的原因必选:
    "Буцаан авах хүсэлт гаргах шалтгааныг сонгоно уу (Шаардлагатай):",
  留言: "Захиа",
  请输入留言: "Захиа оруулна уу",
  没有帐户: "Данс бүртгүүлэхологи",
  钱包充值: "Түрийвчний цэнэглэлт",
  输入您的文字: "Текстээ зурах",
  商家登录: "Худалдаг Нох",
  有关此产品的任何查询: "Энэ бүтээгдэхүүний талаар ямар ч асуулга",
  产品名称: "Бүтээгдэхүүний нэр",
  你的问题: "Чиний асуудал",
  白银店铺: "Мөнгөн дэлгүүр",
  铂金店铺: "Платинум дэлгүүр",
  钻石店铺: "Алан дэлгүүр",
  照片: "хувь гарир",
  已退货: "Эргэсэн",
  邮寄状态: "Захадын маягт",
  订单摘要: "Хийсвэр захиалах",
  收件地址: "Орон сууцны хаяг",
  订购日期: "Захиалга хугацаа",
  订单状态: "Захиалг өгөх",
  总订单金额: "Нийт захиалгын дүн",
  邮寄方式: "Захирга захиалга хийх арга",
  附加信息: "Нэмэлт мэдээлэл",
  订单详细信息: "Сайгийн өгөх мэдээлэл",
  交货类型: "ХӨЛ сурталчилгаар",
  进行评论: "Сэтгэгдэл",
  已评论: "Сэтгэгдэл",
  订单金额: "Захиалгын хэмжээ",
  优惠券: "Хувьдааны төлбөр",
  统一运费: "Холбогдох ачаа",
  送货地址: "Тээвэр хандуулах хаяг",
  评分: "оноо",
  你的意见: "Таны бодол",
  匿名: "нэргүй",
  现金: "бэлэн мөнгө",
  详情: "Нарийн учир",
  收货地址: "Хүлээн авах хаяг",
  暂时没有对话: "Цаг хугацаа өнгөрөхөд ямар ч яриа байхгүй",
  你: "Та",
  输入您的回复: "Одоо оруулах",
  删除成功: "Эдгээх",
  品牌: "тамга",
  已缴纳的保证金: "Төлсөн маржин",
  黄金店铺: "Алтан дэлгүүр",
  没有更多数据: "Мэдэхгүй байна",
  站内信: "Захидал дээр",
  系统通知: "Тогтоон гэж",
  邮箱: "Шуудан",
  手机号: "Утасны дугаар",
  你的手机号: "Таны гар утасны дугаар",
  营业执照: "Дэдийн зөвшөөрөл",
  你的邮箱: "Таны хайрцагны хайрцгийг",
  搜索结果: "Хайлтын үр дүн",
  系统公告: "Системийн зарлал",
  客服: "үйлчилгээийн үйлчилгээ",
  消息已撤回: "Мэдээ ухсан байна",
  物流详情: "Логистикийн мэдээлэл",
  充值: "хүртэл аас",
  提现: "Унрэх",
  信用分: "Зээл",
  余额: "Тэнцвэр",
  佣金: "даалгавар",
  继续购物: "Худалдан авалтыг үргэлжлүүлэх",
  订单结算: "Захиалгын газар",
  加入对比: "Харьцуулалт нэмэх",
  佣金余额: "Комиссын үлдэгдэл",
  刷新: "тэнхрэх",
  刷新成功: "Тэнхрэх",
  官网: "Албан ёсны вэбсайт",
  税号: "ТХийн татварын дугаар",
  订单: "Захиалга",
  合计: "нийт",
  系统安全: "Системийн аюулгүй байдал",
  Recharge_Money_Limit: "Цэнэглэх хэмжээ {мин} ба {max} хооронд байх ёстой",
  限时优惠: "Хязгаарлагдмал цаг",
  高价回收: "Өндөр боловсруулсан дахин боловсруулах",
  姓名: "Нэр",
  商品订单号: "Барааны захиалгын дугаар",
  商品在线回收: "Бараа бүтээгдэхүүний онлайн дахин боловсруулах",
  提交: "бууж өгөх",
  回收记录: "Сэргээх чатир",
  回收状态: "Сэргээхгийн байдал",
  回收价格: "Дахин ашиглах үнэ",
  纳税码: "Татварын код",
  买家登录: "Нэвтрэх",
  买家注册: "бүртгүүлэх",
  language: "Хятад",
  助力提示:
    "Худалдаачид туслахад туслах нь дэлгүүрийн дэлгүүрүүдийн тоймонгийн нөлөөнүүдийг нэмэгдүүлэх боломжтой бөгөөд хэр өндөрт хуримтлагдсан өдрүүдийн тоо томрох тусам улам ихэссэн.",
  已累计助力: "Хуримтлагдсан тусламж",
  今日已助力: "Өнөөдөр тусалсан",
  立即助力: "Тэр даруй туслах",
  商家助力: "Худалдааны тусламж",
  证件号码: "ID дугаар",
  证书号码: "Гэрчилгээний дугаар",
  男鞋: "Эрэгтэй гутал",
  游戏玩具: "Тоглоомын тоглоом",
  使用条款: "Хэрэглээний Нормц",
  商家: "Наймаачин",
  已助力: "Тусалсан",
  被助力: "Тусалж байна",
  用户: "хэрэглэгч",
  助力记录: "Бичлэг хийх",
  消息类型: "Захиа хаяг",
  消息内容: "Захаан агуулга",
  链接: "Эгнээ",
  文本: "сэдэв",
  清空: "Саруул",
  评论成功: "Тайлбар амжилттай болсон",
  扫描二维码: "QR кодыг сканнердах",
  转入: "руу шилжүүлэх",
  收款: "Цуглуулга",
  任务下单中心: "Даалгаврын захиалгын төв",
  记录: "бичлэг",
  任务倒计时: "Даалгаврын тоолол",
  倒计时后自动放弃: "Тооцооллын дараа автоматаар бууж өгнө",
  业务码: "Бизнесийн код",
  选择商品分类: "Бүтээгдэхүүний ангиллыг сонгоно уу",
  可多选: "Олон сонголт хийх боломжтой",
  加载分类中: "Ангилалуудыг ачаалж байна",
  暂无分类: "Одоогоор ангилал алга",
  产品类别: "Бүтээгдэхүүний ангилал",
  账户余额: "Дансны үлдэгдэл",
  立即结算: "Шууд тооцоо хийнэ",
  任务已自动放弃: "Даалгаврыг автоматаар орхисон",
  商品分类: "Бүтээгдэхүүний ангилал",
  订单详情: "Захиалгын дэлгэрэнгүй мэдээлэл",
  预计收益: "Тооцоолсон орлого",
  预计佣金收益: "Тооцоолсон комиссын орлого",
  收益率: "Ургац",
  扣款账户: "Дебит данс",
  确认结算: "Төлбөрийг баталгаажуулах",
  未选择: "Сонгоогүй",
  请选择商品分类: "Бүтээгдэхүүний ангилал сонгоно уу",
  下单成功: "Захиалга амжилттай хийгдсэн",
  下单失败: "Захиалга амжилтгүй боллоо",
  请重试: "Дахин оролдоно уу",
  订单记录: "Захиалгын бүртгэл",
  没有更多了: "дахиад байхгүй",
  业务号: "Бизнесийн дугаар",
  商品类型: "Бүтээгдэхүүний төрөл",
  佣金收益: "комиссын орлого",
  待结算: "Хүлээгдэж буй тооцоо",
  已结算: "Суурин",
  已取消: "Цуцлагдсан",
  加载失败: "Ачааж чадсангүй",
  倒计时: "Countdown",
  随机商品: "санамсаргүй зүйлс",
  为: "төлөө",
  商户助力可提升商品曝光度:
    "Худалдааны тусламж нь бүтээгдэхүүний өртөлтийг нэмэгдүүлэх боломжтой",
  累计助力越高推荐权重越高:
    "Хуримтлагдсан тусламж өндөр байх тусам зөвлөмжийн жин өндөр болно.",
  实时助力动态: "Бодит цагийн тусламжийн динамик",
  助力奖励: "Шагналыг нэмэгдүүлэх",
  随机奖励金额已生成: "Санамсаргүй шагналын хэмжээ бий болсон",
  开心收下: "Хүлээн авахдаа баяртай байна",
  助力已结束: "Тусламж дууссан",
  助力成功: "Амжилтанд туслаарай",
  成功: "амжилт",
  进行中: "Ажиллаж байна",
  等待: "хүлээ",
  助力失败: "Тусламж амжилтгүй боллоо",
  任務: "Даалгавар",
  下单失败_请稍后重试: "Захиалга амжилтгүй боллоо, дараа нь дахин оролдоно уу",
  任务: "Даалгавар"
};
